<template>
  <div>
    <div v-if="load_show">
      <load></load>
    </div>
    <!-- header-->
    <headertop></headertop>

    <div class="main">
      <div class="title">
        <h1 class="left"><i class="el-icon-notebook-2"></i> 反馈列表</h1>
      </div>
      <!-- 搜索框 -->
      <el-input placeholder="负责人/所属课程模块" prefix-icon="el-icon-search" @keyup.enter.native="search_click()"
      	v-model.trim="moderator.search" style="width: 90%;margin: 0 5%;"></el-input>
      <!-- 表格 -->
      <el-row v-if='moderator.list.length==0' style="text-align: center;margin-top: 1.25rem;">
        <h2>还未有反馈哦！！快去提交反馈吧</h2>
      </el-row>
      <el-row v-else>
        <el-table :data="moderator.list" stripe style="width: 90%;margin: 0 5%;" fit>
          <el-table-column sortable label="内容" :show-overflow-tooltip="true">
          	<template slot-scope="scope">
          		<span  style="cursor: pointer;" >
                {{scope.row.content}}
          		</span>
          	</template>
          </el-table-column>
          <el-table-column width="100"  sortable label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
            	<span v-if="scope.row.status==-1" >
            		驳回
            	</span>
              <span v-if="scope.row.status==0" >
              	待处理
              </span>
              <span v-if="scope.row.status==1" >
              	处理中
              </span>
              <span v-if="scope.row.status==2" >
              	已完成
              </span>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="companyee" sortable label="提交人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column width="200" prop="c_time" sortable label="提交时间" show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column width="200" prop="companyee" sortable label="提交时间" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column sortable label="操作" width="100">
          	 <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
              </template>
             </el-table-column>

        </el-table>
        <div class="block center">
          <el-pagination @size-change="(val) => handleSizeChange( val)"
            @current-change="(val) => handleCurrentChange(val)" :current-page="moderator.currentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="moderator.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="moderator.total">
          </el-pagination>
        </div>
      </el-row>

    </div>


    <el-dialog :visible.sync="moderator_dialogVisible" class="moderator_info">
       <div class="text item" >
            <p v-html="moderator_info.name" style="color: #FF0000;font-size: 22px;">
            </p>
            <p class="itema" v-html="moderator_info.answer" style="padding:5px 0px;text-decoration:none;"></p>
            <p style="padding: 10px 0;color: #a5a5a5;font-size: 10px;">发布时间：{{moderator_info.time}}</p>
       </div>
    </el-dialog>



    <el-dialog title='详情' :visible.sync="information.dialog_show" width="60%">
      <el-row>
            反馈问题内容：
            <span v-html="information.list.content"></span>
      </el-row>
      <el-row style="margin-top: 1.25rem;">
          所属课程模块：
          {{information.list.type}}
      </el-row>

      <el-row style="margin-top: 1.25rem;">
          提出人：
          {{information.list.companyee}}
      </el-row>
      <el-row style="margin-top: 1.25rem;">
          提出时间：
          {{information.list.c_time}}
      </el-row>
      <el-row style="margin-top: 1.25rem;">
          状态：
          <span v-if="information.list.status=='-1'">驳回</span>
          <span v-if="information.list.status=='0'">待处理</span>
          <span v-if="information.list.status=='1'">处理中</span>
          <span v-if="information.list.status=='2'">已完成</span>
      </el-row>
      <el-row v-if="information.list.r_id!=''">
        <el-row style="margin-top: 1.25rem;">
            处理人：
            {{information.list.r_id}}
        </el-row>

        <el-row style="margin-top: 1.25rem;">
            备注：
            {{information.list.answer}}
        </el-row>

        <el-row style="margin-top: 1.25rem;">
            处理时间：
            {{information.list.u_time}}
        </el-row>
      </el-row>




      <div slot="footer" class="dialog-footer">
          <el-button @click="information.dialog_show = false " >关 闭</el-button>
        </div>
    </el-dialog>

    <!-- footer -->
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import load from '../../../components/load.vue';
  export default {
    data() {
      return {
        load_show:false,
       information:{
         dialog_show:false,
         list:[],
       },
        moderator: {
          list:[],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          search: '',
          dialog_show:false,
          type_list:[],
          input:'',
          value:''
        },
        moderator_dialogVisible: false,
        moderator_info:[],
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      load:load
    },
    mounted:function(){
      this.load_show=true
      this.get_moderator();
    },
    methods: {
      // moderatorback(){
      //   let _this=this
      //   let data={
      //     type:_this.moderator.value,
      //     content:_this.moderator.input
      //   }
      //   console.log(data)
      //   _this.axios.post('/v2/user/feedback_up', {
      //     data: data //注意post请求发送参数的方式和get请求方式是有区别的
      //   }).then(function(res) {
      //     if(res.status=='200'){
      //       if(res.data.code=='1'){
      //         _this.$message.success(res.data.msg)
      //         _this.get_moderator()
      //         _this.moderator.dialog_show=false
      //       }else{
      //         _this.$message.error(res.data.msg)
      //       }
      //     }else{
      //       _this.$message.error('服务器内部错误')
      //     }
      //   }).catch(function(error) {
      //     _this.$message.error('服务器内部错误')
      //   })
      // },
      add(){
        let _this=this
        _this.moderator.dialog_show=true
        _this.axios.get('/v2/user/feedback_type').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.moderator.type_list=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      search_click(){
        this.get_moderator()
        this.moderator.currentPage=1
        this.moderator.pageSize=10
      },
      get_moderator(){
        let _this=this;
        _this.load_show=true
        _this.axios.get('/v2/user/feedback',{
          params: {
            'keyword':_this.moderator.search,
            'page':_this.moderator.currentPage,
            'limit':_this.moderator.pageSize
          }
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.load_show=false
              _this.moderator.list=res.data.data.data
              _this.moderator.total=res.data.data.total
              _this.moderator.currentPage=res.data.data.current_page
            }else{
              _this.$message.error(res.data.msg)
              _this.load_show=false
            }
          }else{
            _this.$message.error('服务器内部错误')

          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        });
      },
      handleClick(row) {
        let _this=this
        _this.load_show=true
        _this.axios
        .get("/v2/user/feedback_info",
        {params:{num:row.num}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.load_show=false
              _this.information.dialog_show=true
              _this.information.list=res.data.data
            } else {
              _this.load_show=false
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.load_show=false
            _this.$message.error("服务器内部错误")
          }
        });
        _this.information.list=row
      },
      handleSizeChange(val) {
        this.moderator.currentPage = 1
        this.moderator.pageSize = val
        this.get_moderator()
      },
      handleCurrentChange(val) {
        this.moderator.currentPage = val
        this.get_moderator()
      },
    },
  }
</script>

<style scoped>
  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  .moderator_info >>> .el-dialog__body {
      padding: 0px 20px;
  }

  .moderator_info >>> .el-dialog__header {
      padding: 0px 20px 10px;
  }

  .title {
    padding: 20px;
    overflow: hidden;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Moderator/moderator.vue